import React from 'react';
import { Link } from 'react-router-dom';
import './StateCard.css';

const StateCard = ({
    icon: Icon,
    title,
    description,
    tone = 'default',
    actionLabel,
    actionTo,
    actionOnClick,
    compact = false,
    loading = false
}) => {
    return (
        <div className={`platform-state-card tone-${tone} ${compact ? 'compact' : ''}`}>
            {Icon ? (
                <div className={`platform-state-card-icon ${loading ? 'is-loading' : ''}`}>
                    <Icon size={compact ? 20 : 24} />
                </div>
            ) : null}
            <div className="platform-state-card-content">
                {title ? <h3>{title}</h3> : null}
                {description ? <p>{description}</p> : null}
                {actionLabel ? (
                    actionTo ? (
                        <Link to={actionTo} className="platform-state-card-action">
                            {actionLabel}
                        </Link>
                    ) : (
                        <button type="button" className="platform-state-card-action" onClick={actionOnClick}>
                            {actionLabel}
                        </button>
                    )
                ) : null}
            </div>
        </div>
    );
};

export default StateCard;
